import type { SignalTuning } from './SignalTuning';

/**
 * Public runtime-config shape served by the BFF at `/_runtime-config`. Must
 * match `RuntimeConfig` in `src/bff/RuntimeConfigLoader.ts`. Only safe-to-expose
 * fields belong here — never secrets.
 */
export interface RuntimeConfig {
    integrations: {
        awsBedrock: {
            cfnTemplateUrl: string;
            platformAccountId: string;
            cloudFormationStackName: string;
            consoleHostTemplate: string;
        };
    };
    signals: SignalTuning;
}

export const RuntimeConfigToken = Symbol.for('RuntimeConfig');
